import React from "react";
import { Outlet, useLoaderData } from "react-router";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ClientInvoiceBundleWorkflows from "Components/ClientInvoiceBundle/workflows/ClientInvoiceBundleWorkflows";

import {
  getClientInvoiceBundleBybundleID,
  getFileCategory,
  getClients,
} from "API/swesum";

export async function loader({ params }) {
  const clientInvoiceBundle = await getClientInvoiceBundleBybundleID(
    params.bundleID
  );
  const clients = await getClients();
  const files = await getFileCategory("FAKTURABUNT");

  return { clientInvoiceBundle, files, clients };
}

export function ClientInvoiceBundlePage() {
  const { clientInvoiceBundle } = useLoaderData();

  return (
    <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h5" gutterBottom>
          {"Fakturabunt - "}
          {clientInvoiceBundle.Id}
        </Typography>
        <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} md={12}>
            <Outlet />
          </Grid>
          <Grid item xs={12}>
            <ClientInvoiceBundleWorkflows />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
